var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',_vm._b({staticClass:"align-center justify-center",staticStyle:{"width":"150px"},attrs:{"color":_vm.getPhaseColor,"small":"","dark":"","label":""}},'v-chip',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.getPhaseMessage)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }